import IService from "../service";
import ModalLoading from "./models/loading.model";

/**
 * @property $store {RepositoryManager}
 */
export default class LoadingService extends IService {
    /**
     * Getter
     * @returns {RepositoryManager}
     */
    get $store() {
        return this.config.repositories;
    }

    /**
     * Show loading indicator
     * @param [message] {string}
     * @param [timeout] {int}
     * @returns {ModalLoading}
     */
    show(message, timeout) {
        return new ModalLoading(
            this.$store.modals.addLoading(
                message,
                timeout
            )
        );
    }

    /**
     * Hide all loading indicators
     */
    hideAll() {
        this.$store.modals
            .removeAllLoading()
            .catch(() => false);
    }
}